import { connect } from 'react-redux';
import { getPageSize } from '../publicSession/selectors';
var mapStateToProps = function (state) { return ({
    pageSize: getPageSize(state),
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=Pagination.container.js.map